module.exports = __webpack_public_path__ + "img/139ne.242df49f.svg";